export const VEHICLE_TYPES = [
  "Léger",
  "Poids lourd",
  "Poids lourd citerne",
  "Autobus",
];

export const EXTRAS = [
  "Plaque X",
  "Pesé",
  "Matière dangereuse",
  "Mettre du carburant",
  "Autre",
];

export const FUEL_LEVELS = [
  "Vide (E)", "1/8", "1/4", "3/8", "1/2", "5/8", "3/4", "7/8", "Plein (F)",
  "Batterie 0-25%", "Batterie 25-50%", "Batterie 50-75%", "Batterie 75-100%",
];

export const UREA_LEVELS = [
  "S/O (n'utilise pas d'urée)",
  "Vide",
  "1/4",
  "1/2",
  "3/4",
  "Plein",
];

export const KEY_STATUSES = [
  "Réception",
  "Service",
  "Contact",
  "Pare-Soleil",
  "Baguette à l'huile",
  "Autre",
];
